export default "__VITE_ASSET__510f9134__"